export interface IGetRedisKeysRequest {
    pattern?: string;
    project?: string;
    tenantId?: string;
    ano?: string;
    route?: string;
}
